module.exports = __webpack_public_path__ + "img/event-ete-oh-parc.fdfa5e6.jpg";